'use strict';
import React from 'react';

import CircularProgress from "@material-ui/core/CircularProgress";
import PropTypes from "prop-types";
import {baseStyles, BORDER_RADIUS, withMultipleStyles} from "../../../styles/Styles";
import FormHelperText from "@material-ui/core/FormHelperText";
import Autocomplete, {createFilterOptions} from '@material-ui/lab/Autocomplete';
import TextField from "@material-ui/core/TextField";
import {ColorNegative} from "../../../styles/Colors";
import {Chip, Typography} from "@material-ui/core";
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import TextView from "src/js/components/commons/TextView";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const useStyles = () => ({
  acHelper: {
    width: '100%',
    textAlign: 'left',
    marginLeft: -2,
    marginTop: -2,
  },
  acHelperError: {
    width: '100%',
    textAlign: 'left',
    marginLeft: -2,
    marginTop: -2,
    color: ColorNegative,
  }
});

export const FilterOptionsStart = createFilterOptions({
  matchFrom: 'start',
  stringify: (option) => option.name,
});

export const FilterOptionsAny = createFilterOptions({
  matchFrom: 'any',
  stringify: (option) => option.name,
});

class AutoCompleteView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: 0
    }
  }

  open = () => {
    this.setState({open: 1});
  }

  render() {
    const {classes, label, placeholder, variant, autoFocus, required, hasSubOptions, multiple, multipleLimit, disabled, loading, filterOptions, options, selectedValues, selectedSubValues, inputValue, error, errorText, helperText, searchTextLength, renderInputProps, onInputChange, onSelect} = this.props;
    let eMultipleLimit = multipleLimit;
    if (eMultipleLimit === undefined) {
      eMultipleLimit = 999999999;
    }
    const textVariant = variant || "filled";
    return (
      <Autocomplete
        open={this.state.open}
        onOpen={() => {this.setState({open: 1})}}
        onClose={() => {this.setState({open: 0})}}
        autoFocus={autoFocus}
        required={required}
        fullWidth
        multiple={multiple}
        freeSolo={!multiple || !selectedValues || selectedValues.length === 0 || selectedValues.length < eMultipleLimit}
        getOptionDisabled={(option) => {
          if (multiple && selectedValues && selectedValues.length >= eMultipleLimit) {
            if (!selectedValues || !selectedValues.includes(option)) {
              return true;
            }
          }
          return false;
        }}
        disabled={disabled}
        size={'medium'}
        filterOptions={this.filterOptions}
        getOptionSelected={(option, value) => option.name === value.name}
        getOptionLabel={(option) => multiple || option ? option.name : option}
        disableCloseOnSelect={multiple}
        forcePopupIcon={options && options.length > 0}
        openOnFocus
        options={options || []}
        inputMode={"text"}
        inputValue={inputValue ? inputValue :''}
        value={selectedValues ? selectedValues : multiple ? [] : ''}
        onInputChange={(event, newInputValue, reason) => {
          if (reason === 'reset') {
            return;
          }
          if (!multiple || !selectedValues || selectedValues.length === 0 || selectedValues.length < eMultipleLimit) {
            // if (this.timeoutHandler) {
            //   clearTimeout(this.timeoutHandler);
            // }
            // this.timeoutHandler = setTimeout(() => {
              onInputChange(newInputValue);
            // }, 100);
          } else {
            // if (this.timeoutHandler) {
            //   clearTimeout(this.timeoutHandler);
            // }
            // this.timeoutHandler = setTimeout(() => {
              onInputChange('');
            // }, 100);
          }
        }}
        onChange={(event, value, reason, details) => {
          if (hasSubOptions) {
            if (reason === 'remove-option' && details.option && details.option.subOptions) {
              selectedSubValues[details.option.id] = null;
            } else if (reason === 'clear' && selectedValues) {
              selectedValues.forEach((item) => {
                selectedSubValues[item.id] = null;
              });
            }
          }
          onSelect(value, selectedSubValues);
        }}
        renderOption={(option, optionState) => {
          if (this.props.renderOption) {
            return this.props.renderOption(option, optionState);
          }
          const {selected} = optionState;
          return (
            <React.Fragment>
              <div style={{width: '100%'}}>
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                  {multiple ?
                    <Checkbox
                      size={"small"}
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{margin: -6}}
                      checked={selected}
                    />
                    : null
                  }
                  <TextView numberOfLines={2} align={'left'} style={{marginLeft: 6, marginRight: 6, maxHeight: 48, overflow: 'hidden'}}>{option.name}</TextView>
                </div>
                {hasSubOptions && selected && option.subOptions ?
                  <List style={{padding: 0}}>
                    {option.subOptions.map((subOption) => {
                      let isSelected = false;
                      selectedValues.forEach((item) => {
                        if (item && item.id === option.id) {
                          if (selectedSubValues) {
                            const subOptionsSelected = selectedSubValues[item.id];
                            if (subOptionsSelected) {
                              for (let i = 0; i < subOptionsSelected.length; i++) {
                                const subItem = subOptionsSelected[i];
                                if (subItem.id === subOption.id) {
                                  isSelected = true;
                                }
                              }
                            }
                          }
                        }
                      });
                      return (
                        <ListItem button style={{padding: 2, marginLeft: 26, marginRight: 26}} onClick={(event) => {
                          event.stopPropagation();
                          selectedValues.forEach((item) => {
                            if (item && item.id === option.id) {
                              let checkedAlreadyIndex = -1;
                              if (selectedSubValues) {
                                let subOptionsSelected = selectedSubValues[item.id];
                                if (subOptionsSelected) {
                                  for (let i = 0; i < subOptionsSelected.length; i++) {
                                    const subItem = subOptionsSelected[i];
                                    if (subItem.id === subOption.id) {
                                      checkedAlreadyIndex = i;
                                    }
                                  }
                                } else {
                                  subOptionsSelected = [];
                                  selectedSubValues[item.id] = subOptionsSelected;
                                }
                                if (checkedAlreadyIndex !== -1) {
                                  subOptionsSelected.splice(checkedAlreadyIndex, 1);
                                } else {
                                  subOptionsSelected.push(subOption);
                                }
                              }
                            }
                          });
                          onSelect(selectedValues, selectedSubValues);
                        }}>
                          <div className={classes.viewRowFullWidth} style={{alignItems: 'center'}}>
                            <Checkbox
                              size={"small"}
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{margin: -6}}
                              checked={isSelected || false}
                            />
                            <Typography style={{marginLeft: 6, marginRight: 6}}>{subOption.name}</Typography>
                          </div>
                        </ListItem>
                      )
                    })}
                  </List>
                  : null
                }
              </div>
            </React.Fragment>
          )
        }}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => {
            let chipName = option.name;
            if (hasSubOptions && selectedSubValues) {
              const subOptionsSelected = selectedSubValues[option.id];
              if (subOptionsSelected) {
                if (chipName.length > 40) {
                  chipName = chipName.substring(0, 40) + '...';
                }
                let subChipName = '';
                let count = 0;
                subOptionsSelected.forEach((subOption) => {
                  if (count > 0) {
                    subChipName += ', ';
                  }
                  subChipName += subOption.name;
                  count++;
                });
                if (subChipName && subChipName.length > 0) {
                  chipName += ': [' + subChipName + ']';
                }
              }
            }
            return (
              <Chip
                size={'small'}
                key={option.id}
                style={{height:"100%", borderRadius: BORDER_RADIUS}}
                label={<TextView numberOfLines={2} align={'left'} variant={'body2'} style={{whiteSpace: 'normal', padding: 1}}>{chipName}</TextView>}
                {...getTagProps({index})}
              />
            );
          })
        }
        renderInput={(params) => (
          <TextField
            {...params}
            ref={ref => this.refInput = ref}
            variant={'filled'}
            required={required}
            fullWidth
            size={'small'}
            label={label}
            // disabled={multiple && selectedValues && selectedValues.length >= multipleLimit ? true : false}
            disabled={this.props.disabled}
            placeholder={multiple && selectedValues && selectedValues.length >= multipleLimit ? '' : placeholder}
            error={error}
            helperText={errorText ? <FormHelperText className={classes.acHelperError}>{errorText}</FormHelperText> : helperText ? <FormHelperText className={classes.acHelper}>{helperText}</FormHelperText> : null}
            InputProps={{
              ...params.InputProps,
              disableUnderline: true,
              endAdornment: (
                <React.Fragment>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
              ...renderInputProps,
            }}
          />
        )}
      />
    );
  }

  filterOptions = createFilterOptions({
    matchFrom: 'any',
    stringify: (option) => option.name,
  });
}

AutoCompleteView.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  highlighted: PropTypes.bool,
  autoFocus: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  variant: PropTypes.string,
  hasSubOptions: PropTypes.bool,
  multiple: PropTypes.bool,
  multipleLimit: PropTypes.number,
  filterOptions: PropTypes.object,
  options: PropTypes.array,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  errorText: PropTypes.string,
  helperText: PropTypes.string,
  selectedValues: PropTypes.object | PropTypes.array,
  selectedSubValues: PropTypes.object,
  searchTextLength: PropTypes.number,
  inputValue: PropTypes.string,
  onInputChange: PropTypes.func,
  onSelect: PropTypes.func,
}

export default withMultipleStyles(baseStyles, useStyles)(AutoCompleteView);
